import { render } from "./contratoDetalheView.vue?vue&type=template&id=ac63df58"
import script from "./contratoDetalheView.vue?vue&type=script&lang=js"
export * from "./contratoDetalheView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__